import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { MediumGroup, MediumType, TravelCardType } from '../medium.model';
import { MediumActions } from './medium.actions';
import { PurchaseMediumPartialStoreState } from './medium.reducer';
import * as MediumSelectors from './medium.selectors';
import { RelatedCard, RidangoReduxAction } from '@ridango/core';

@Injectable()
export class MediumFacade {
    medium$: Observable<any> = this.store.select(MediumSelectors.selectedMedium);
    cardTypeMask$: Observable<any> = this.store.select(MediumSelectors.cardTypeMask);
    availableMediumGroups$ = this.store.select(MediumSelectors.availableMediumGroups);
    selectedMediumGroup$ = this.store.select(MediumSelectors.selectedMediumGroup);

    constructor(private store: NgRedux<PurchaseMediumPartialStoreState>, private actions: MediumActions) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }


    private setSelectedMedium(medium: any) {
        this.dispatch(this.actions.setSelectedMedium(medium));
    }

    setRelatedCardMedium(relatedCard: RelatedCard) {
        this.setSelectedMedium({ type: MediumType.RelatedCard, relatedCardId: relatedCard.id });
    }

    setTravelCardMedium(cardNumber: string, mediumType: MediumType, travelCardType: TravelCardType) {
        this.setSelectedMedium({
            type: mediumType,
            cardId: cardNumber,
            cardType: travelCardType,
        });
    }
    setEmailMedium(email: string) {
        this.setSelectedMedium({
            type: MediumType.Email,
            email: email,
            cardType: TravelCardType.Email,
        });
    }
    setVoucherMedium(email: string) {
        this.setSelectedMedium({
            type: MediumType.Voucher,
            email: email,
            cardType: TravelCardType.Voucher,
        });
    }

    setCardTypeMask(cardTypeMask: number) {
        this.dispatch(this.actions.setCardTypeMask(cardTypeMask));
    }

    setAvailableMediumGroups(groups: MediumGroup[]) {
        this.dispatch(this.actions.setAvailableMediumGroups(groups));
    }
    setSelectedMediumGroup(group: MediumGroup) {
        this.dispatch(this.actions.setSelectedMediumGroup(group));
    }

    resetSelectedMedium() {
        this.dispatch(this.actions.resetSelectedMedium());
    }

    clear() {
        this.store.dispatch(this.actions.clearMedium());
    }
}
